import { useResource } from "Infrastructure/Translation/Resources";
import {
	ElementType,
	type ProgressElement,
} from "Order/Modules/Payment/Components/PaymentLegend";
import { Box, Tooltip } from "@mui/material";
import { motion } from "motion/react";

const ANIMATION_DURATION = 0.75;

type VerticalBarChartProps = {
	elements: ProgressElement[];
	total: number;
};

export function VerticalBarChart({ elements, total }: VerticalBarChartProps) {
	const { t } = useResource();

	return (
		<Box position="relative">
			<Box height={15} borderRadius={5} bgcolor="grey.300" overflow="hidden">
				{elements.map(({ color, value, type, label }, index) => {
					const percentage = Math.min((value / total) * 100, 100);
					if (type === ElementType.bar) {
						return (
							<Box
								key={`${index}-${value}`}
								component={motion.div}
								initial={{ width: 0 }}
								animate={{ width: `${percentage}%` }}
								transition={{
									duration: ANIMATION_DURATION,
									ease: "easeInOut",
									delay: ANIMATION_DURATION * index,
								}}
								whileHover={{ opacity: 0.5 }}
								sx={{
									height: "100%",
									backgroundColor: color,
									borderRadius: "35px",
									transformOrigin: "left",
									position: "absolute",
									zIndex: 1,
								}}
							>
								<Tooltip title={`${t(label)}`} arrow>
									<Box width="100%" height="100%" />
								</Tooltip>
							</Box>
						);
					}
					if (type === ElementType.breakpoint) {
						return value > 0 ? (
							<Box
								key={`${index}-${value}`}
								sx={{
									position: "absolute",
									left: `calc(${percentage}% - 1px)`,
									height: "150%",
									width: "2px",
									backgroundColor: color,
									top: "-25%",
									zIndex: 2,
								}}
							/>
						) : null;
					}
					return null;
				})}
			</Box>
		</Box>
	);
}
